export default "__VITE_ASSET__DSosX7vM__"